import { useState } from "react";
import { ArrowRight, Check, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiError } from "../lib/api";

/** Footer "get the weekly menu" signup — feeds the Thursday menu email. */
export const NewsletterSignup = () => {
  const [email, setEmail] = useState("");
  const [state, setState] = useState("idle");

  const submit = async (e) => {
    e.preventDefault();
    setState("sending");
    try {
      await api.post("/subscribe", { email, source: "footer" });
      setState("done");
    } catch (err) {
      toast.error(formatApiError(err));
      setState("idle");
    }
  };

  if (state === "done") {
    return (
      <p className="mt-5 inline-flex items-center gap-2 rounded-full bg-halal/15 px-4 py-2 text-sm font-semibold text-halal" data-testid="newsletter-done">
        <Check size={14} /> You're on the list — see you Thursday.
      </p>
    );
  }

  return (
    <form onSubmit={submit} className="mt-5 max-w-sm" data-testid="newsletter-form">
      <label htmlFor="newsletter-email" className="font-mono text-xs uppercase tracking-[0.25em] text-saffron">Get the weekly menu</label>
      <p className="mt-2 text-xs leading-relaxed text-parchment/60">Every Thursday morning: the new dishes, straight to your inbox. No spam, unsubscribe anytime.</p>
      <div className="mt-3 flex overflow-hidden rounded-full border border-parchment/20 bg-parchment/5 focus-within:border-saffron">
        <input
          id="newsletter-email"
          type="email"
          required
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="you@example.com"
          className="min-w-0 flex-1 bg-transparent px-4 py-2.5 text-sm text-parchment outline-none placeholder:text-parchment/40"
          data-testid="newsletter-email-input"
        />
        <button type="submit" disabled={state === "sending"} aria-label="Subscribe" className="flex items-center justify-center bg-saffron px-4 text-ink transition-colors hover:bg-parchment disabled:opacity-60" data-testid="newsletter-submit-btn">
          {state === "sending" ? <Loader2 size={16} className="animate-spin" /> : <ArrowRight size={16} />}
        </button>
      </div>
    </form>
  );
};
